"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCS_PRESET_SCHEMA = exports.postFetcher = exports.restFetcher = void 0;
exports.loggedOperation = loggedOperation;
exports.fetchEndpointConfig = fetchEndpointConfig;
exports.createSnapshot = createSnapshot;
exports.deployIndex = deployIndex;
const restFetcher = async (url, options) => {
    const response = await fetch(url, options);
    if (response.status === 0) {
        throw new Error(`Request failed (network error): ${await response.text()}`);
    }
    else if (response.status >= 400) {
        const error = new Error(`Request failed (HTTP error ${response.status})}`);
        error.response = response;
        throw error;
    }
    return await response.json();
};
exports.restFetcher = restFetcher;
const postFetcher = async (url, body, headers) => {
    return await (0, exports.restFetcher)(url, {
        method: 'POST',
        headers: {
            ...headers,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
};
exports.postFetcher = postFetcher;
async function loggedOperation(preMessage, fn, postMessage) {
    if (preMessage != null) {
        console.debug(preMessage);
    }
    try {
        const response = await fn();
        if (postMessage != null) {
            console.debug(postMessage);
        }
        return response;
    }
    catch (error) {
        throw new Error(`Error: ${error.message}`);
    }
}
async function fetchEndpointConfig(baseUrl, APIKey, indexId) {
    const result = await loggedOperation('Start: Fetch index endpoint config', async () => await (0, exports.restFetcher)(`${baseUrl}/api/v1/indexes/get-index?id=${indexId}`, {
        headers: {
            Authorization: `Bearer ${APIKey}`
        }
    }), 'End: Fetch index endpoint config (success)');
    return { endpoint: result === null || result === void 0 ? void 0 : result.api_endpoint, public_api_key: result === null || result === void 0 ? void 0 : result.api_key };
}
async function createSnapshot(baseUrl, APIKey, indexId, documents) {
    await loggedOperation('Start: Create snapshot', async () => await (0, exports.postFetcher)(`${baseUrl}/api/v1/webhooks/${indexId}/snapshot`, documents, {
        Authorization: `Bearer ${APIKey}`
    }), 'End: Create snapshot (success)');
}
async function deployIndex(baseUrl, APIKey, indexId) {
    await loggedOperation('Start: Deploy index', async () => await (0, exports.postFetcher)(`${baseUrl}/api/v1/webhooks/${indexId}/deploy`, {}, {
        Authorization: `Bearer ${APIKey}`
    }), 'End: Deploy index (success)');
}
exports.DOCS_PRESET_SCHEMA = {
    title: 'string',
    content: 'string',
    path: 'string',
    section: 'string',
    category: 'enum',
    version: 'enum'
};
